import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const StyedDefaultWrapper = styled('div')(({ theme }) => ({
  minHeight       : '100vh',
  backgroundColor : theme.palette.primary.white1,
  display         : 'flex',
  flexDirection   : 'column',
}));

export const StyledContent = styled(Box)(({ margin, marginSm, theme }) => ({
  flex                           : '1',
  margin                         : margin ?? '10px 78px 0px 78px',
  [theme.breakpoints.down('sm')] : {
    margin : marginSm ?? '15px',
  },
}));

export const StyledChildrenWrapper = styled(Box)(({ theme }) => ({
  width    : '150vw',
  maxWidth : 'fill-available',
}));
